import { Button } from "@win-reality/react-ui";

import type { TTeamSides } from "../store/types";

type TeamPanelProps = {
  side: TTeamSides;
  teamName: string;
  onSelectTeam: () => void;
};

/**
 * TeamPanel - Display panel for one team (away or home)
 *
 * Shows either a "Select Team" button or the selected team name
 */
export const TeamPanel = ({ side, teamName, onSelectTeam }: TeamPanelProps) => {
  const isTeamSelected = teamName.length > 0;
  const label = side === "away" ? "AWAY" : "HOME";

  return (
    <div className="flex flex-1 flex-col items-center justify-center">
      <h2 className="mb-6 text-xl font-regular tracking-wide text-text-light">
        {label}
      </h2>

      {!isTeamSelected ? (
        <Button
          variant="secondary-flat-light"
          size="default"
          onClick={onSelectTeam}
          className="min-w-[200px] rounded-full"
        >
          Select Team Roster
        </Button>
      ) : (
        <div className="flex flex-col items-center gap-4">
          <span className="text-xl font-semibold uppercase text-text-light">
            {teamName}
          </span>
          <Button
            variant="ghost"
            size="sm"
            onClick={onSelectTeam}
            className="text-accent-dark-3 underline"
          >
            Change Team
          </Button>
        </div>
      )}
    </div>
  );
};
